import type { FeatureOfferPort } from "./FeaturePurchaseTypes";

/**
 * The title's `FeatureOfferPort` (decision 51) before the control bar builds the purchase flow, which comes after the
 * title's presentation: it refuses until bound, and stays unbound where there is no flow (replay mode, no offers).
 */
export class DeferredFeatureOfferPort implements FeatureOfferPort {
  private target: FeatureOfferPort | null = null;

  public bind(target: FeatureOfferPort): void {
    this.target = target;
  }

  public promptOffer(offerId: string): boolean {
    return this.target?.promptOffer(offerId) ?? false;
  }
}
